function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { CommandHistoryPanel, ConsolePanel, FileExplorerPanel, LogPanel } from '@deephaven/dashboard-core-plugins';
import Log from '@deephaven/log';
import { isLayoutV1, isLayoutV2 } from "./LayoutStorage.js";
var log = Log.module('UserLayoutUtils');
export var DEFAULT_LAYOUT_CONFIG = {
  layoutConfig: [{
    type: 'column',
    content: [{
      type: 'row',
      height: 40,
      // slightly smaller than 50-50 to allow more space for tables below
      content: [{
        type: 'stack',
        content: [{
          type: 'react-component',
          component: ConsolePanel.COMPONENT,
          title: ConsolePanel.TITLE,
          isClosable: false
        }, {
          type: 'react-component',
          component: LogPanel.COMPONENT,
          title: LogPanel.TITLE,
          isClosable: false
        }]
      }, {
        type: 'stack',
        width: 25,
        content: [{
          type: 'react-component',
          component: CommandHistoryPanel.COMPONENT,
          title: CommandHistoryPanel.TITLE,
          isClosable: false
        }, {
          type: 'react-component',
          component: FileExplorerPanel.COMPONENT,
          title: FileExplorerPanel.TITLE,
          isClosable: false
        }]
      }]
    }, {
      type: 'row',
      content: [{
        type: 'stack',
        title: 'Notebooks',
        content: []
      }]
    }]
  }],
  links: [],
  filterSets: [],
  version: 2
};
export var DEFAULT_LAYOUT_CONFIG_NO_CONSOLE = {
  layoutConfig: [],
  links: [],
  filterSets: [],
  version: 2
};
export function normalizeLayout(layout) {
  if (isLayoutV2(layout)) {
    return layout;
  }
  if (isLayoutV1(layout)) {
    var layoutConfig = layout;
    return {
      layoutConfig,
      links: [],
      filterSets: [],
      version: 2
    };
  }
  throw new Error("Unexpected layout import format: ".concat(layout));
}

/**
 * Get the default layout for the user to use. Checks layout storage for any layouts, and uses the first one if found.
 * @param layoutStorage  The layout storage to get the default layouts from
 * @param isConsoleAvailable Whether console sessions are available.
 * @returns The default layout config to use
 */
export function getDefaultLayout(_x) {
  return _getDefaultLayout.apply(this, arguments);
}
function _getDefaultLayout() {
  _getDefaultLayout = _asyncToGenerator(function* (layoutStorage) {
    var isConsoleAvailable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    try {
      var layouts = yield layoutStorage.getLayouts();
      if (layouts.length > 0) {
        try {
          // We found a layout on the server, use it. It could be an empty layout if they want user to build their own
          var layout = yield layoutStorage.getLayout(layouts[0]);
          return normalizeLayout(layout);
        } catch (err) {
          log.error('Unable to load layout', layouts[0], ':', err);
          log.warn('No valid layouts found, falling back to default layout');
        }
      }
    } catch (err) {
      log.error('Unable to fetch layout list', err);
      log.warn('Falling back to default layout');
    }
    // Otherwise, do the default layout
    return isConsoleAvailable ? DEFAULT_LAYOUT_CONFIG : DEFAULT_LAYOUT_CONFIG_NO_CONSOLE;
  });
  return _getDefaultLayout.apply(this, arguments);
}
export function exportLayout(data) {
  var _ref = data,
    filterSets = _ref.filterSets,
    layoutConfig = _ref.layoutConfig,
    links = _ref.links,
    pluginDataMap = _ref.pluginDataMap;
  var exportedLayout = {
    filterSets,
    layoutConfig,
    links,
    pluginDataMap,
    version: 2
  };
  return exportedLayout;
}
export default {
  exportLayout,
  getDefaultLayout,
  normalizeLayout
};
//# sourceMappingURL=UserLayoutUtils.js.map